import { sortBy } from 'lodash';
import config from '~/config';
import storage from '~/util/storage';
import http from './http';

export const getUsersForFirm = async (firmId) => {
    try {
        const url = `${config.urls.base}/lawfirm/${firmId}/users`;
        const response = await http.get2(url);

        if (response.errored) {
            throw new Error(response.error);
        }
        
        return sortBy(response, ['firstName']);

    } catch (err) {
        console.error(err);
        return null;
    }
};

export const getFirms = async () => {
    try {
        const cached = getCached();

        if (Array.isArray(cached))
            return cached;

        const results = await http.get(`${config.urls.base}/lawfirm`);

        if (results.errored) {
            throw new Error(results.error);
        }

        const val = sortBy(results, ['Name']);
        
        setCached(val);
        return val;

    } catch (err) {
        console.error(err);
        return [];
    }
};

export const getFirmById = async firmId => {
    try {

        const cached = getCached();

        if (Array.isArray(cached)) {
            const firm = cached.find(f => f.Id == firmId);

            if (firm != null)
                return firm;
        }

        const result = await http.get(`${config.urls.base}/lawfirm/${firmId}`);

        if (result.errored) {
            throw new Error(result.error);
        }

        return result[0];

    } catch (err) {
        console.error(err);
        return {};
    }
};

const getCached = () => storage.getItem('trt.lawfirms');
const setCached = (firms) => storage.setItem('trt.lawfirms', firms);

export default {
    getUsersForFirm,
    getFirms,
    getFirmById
};